import type { ContactFormValues } from '@presentation/components';
import { ContactForm } from '@presentation/components';
import { Formik } from 'formik';
import { useSendContactMessage } from './api/useSendContactMessage';
import { useValidationSchema } from './useValidationSchema';

export const ContactFormController = () => {
  const { validationSchema } = useValidationSchema();
  const { sendContactMessageFromForm } = useSendContactMessage();
  const initialValues: ContactFormValues = {
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    messageContent: '',
    confirmedForm: false,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={async (values, { resetForm }) => {
        await sendContactMessageFromForm(values);
        resetForm();
      }}
    >
      <ContactForm />
    </Formik>
  );
};
